/* Yo Gorilla Mats, direction G "Black & Gold": small progressive enhancements, no dependencies.
   Size lineup: the Exercise / Yoga toggle shows one line at a time. Without this file both lines show, one under
   the other (the hide rule only applies under html.ygm-js, which the layout sets before first paint). Size guide: see
   initSizeGuides. Cart page and cart drawer: see initCartPage and initDrawer. */
(() => {
  function initLineups(root) {
    root.querySelectorAll('[data-ygm-lineup]:not([data-ready])').forEach((sec) => {
      sec.dataset.ready = '1';
      const btns = sec.querySelectorAll('[data-lu-line]');
      const lines = sec.querySelectorAll('[data-lu-for]');
      const show = (key) => {
        btns.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.luLine === key)));
        lines.forEach((l) => l.classList.toggle('is-on', l.dataset.luFor === key));
      };
      btns.forEach((b) => b.addEventListener('click', () => show(b.dataset.luLine)));
    });
  }

  /* Size guide: the Exercise / Yoga toggle shows one line; a size tile redraws the black mat (CSS variables on the
     floor drive the size, the yoga-mat outline and the foot labels, so the change animates) and fills the panel from
     the tile's data. Hovering or focusing a tile lights that size's outline in gold. */
  function initSizeGuides(root) {
    root.querySelectorAll('[data-ygm-sg]:not([data-ready])').forEach((sec) => {
      sec.dataset.ready = '1';
      const segs = sec.querySelectorAll('[data-sg-line]');
      const lines = sec.querySelectorAll('[data-sg-for]');
      segs.forEach((b) => b.addEventListener('click', () => {
        segs.forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
        lines.forEach((l) => l.classList.toggle('is-on', l.dataset.sgFor === b.dataset.sgLine));
      }));
      lines.forEach((line) => {
        const floor = line.querySelector('.ygm-gsg__floor');
        const tiles = line.querySelectorAll('[data-sg-k]');
        const outlines = line.querySelectorAll('.ygm-gsg__ol');
        const r = (k) => line.querySelector(`[data-r="${k}"]`);
        const hint = (k) => outlines.forEach((o) => o.classList.toggle('is-hint', o.dataset.k === k));
        const pick = (t) => {
          const d = t.dataset;
          tiles.forEach((x) => x.setAttribute('aria-pressed', String(x === t)));
          outlines.forEach((o) => o.classList.toggle('is-on', o.dataset.k === d.sgK));
          floor.style.setProperty('--sl', d.l);
          floor.style.setProperty('--sw', d.w);
          const label = `${d.l}′ × ${d.w}′`;
          const set = (k, v) => { const el = r(k); if (el) el.textContent = v; };
          set('dl', `${d.l} ft`); set('dw', `${d.w} ft`);
          set('size', label); set('meta', d.meta); set('ratio', d.ratio); set('best', d.best); set('spec', d.spec);
          set('price', d.price); set('ctatext', `${d.price === 'Sold out' ? 'See' : 'Shop'} the ${label}`);
          const cta = r('cta'); if (cta) cta.href = d.url;
        };
        tiles.forEach((t) => {
          t.addEventListener('click', () => pick(t));
          t.addEventListener('pointerenter', () => hint(t.dataset.sgK));
          t.addEventListener('pointerleave', () => hint(null));
          t.addEventListener('focus', () => hint(t.dataset.sgK));
          t.addEventListener('blur', () => hint(null));
        });
      });
    });
  }

  /* Colour row on an all-sizes product page: the block renders one row of swatches per size (availability differs by
     size) and shows the selected size's row. When a size tile is picked, show that size's row. */
  function syncColours(variantId) {
    const id = String(variantId);
    document.querySelectorAll('[data-ygm-colors]').forEach((box) => {
      const sets = box.querySelectorAll('[data-for-variant]');
      if (![...sets].some((s) => s.dataset.forVariant === id)) return;
      sets.forEach((s) => { s.hidden = s.dataset.forVariant !== id; });
    });
  }
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (t instanceof HTMLInputElement && t.checked && t.dataset.variantId && t.closest('.ygm-gsize__set')) { pickColour(null); syncColours(t.dataset.variantId); }
  });

  /* A colour chip picks that size's own colour variant in place (owner 10-19: never leave the page). The block only
     offers colours in stock at the same price, so the price shown stays right. The chosen variant id is written into
     every add-to-cart form on the page and re-applied at submit (Horizon may re-render the form). A size change (above)
     drops back to the default colour, whose id Horizon's own re-render puts back. */
  let colourVid = null;
  const productForms = () => document.querySelectorAll('product-form-component form, form[data-type="add-to-cart-form"]');
  function pickColour(chip) {
    const set = chip ? chip.closest('[data-for-variant]') : null;
    document.querySelectorAll('[data-ygm-colors] [data-for-variant]').forEach((s) => {
      if (set && s !== set) return;
      s.querySelectorAll('button.ygm-gcol__chip').forEach((b) => {
        const on = chip ? b === chip : b.dataset.vid === s.dataset.forVariant;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', String(on));
        if (on) { const n = s.querySelector('[data-colour-name]'); if (n) n.textContent = b.dataset.name; }
      });
      s.querySelectorAll('[data-peek]').forEach((p) => { p.hidden = !chip || p.dataset.peek !== chip.dataset.vid; });
    });
    colourVid = chip && chip.dataset.vid !== set.dataset.forVariant ? chip.dataset.vid : null;
    if (chip) productForms().forEach((f) => { const i = f.querySelector('input[name="id"]'); if (i) i.value = chip.dataset.vid; });
    document.querySelectorAll('[data-ygm-sticky-colour]').forEach((el) => { el.textContent = chip ? chip.dataset.name : el.dataset.default || el.textContent; });
    filterGallery(chip ? colourKey(chip.dataset.name) : null);
  }

  /* The gallery follows the picked colour (owner 10-19: "have the images change between colors"). Slides and
     thumbnails carry data-ygm-col (snippet ygm-media-colour, from the photo's alt text). Picking a colour keeps only
     that colour's slides (plus untagged ones, such as a drawn colour slide) in the slideshow, in their original order,
     renumbers the thumbnails, fixes the phone counter's total and opens on the first one. Removed slides are kept and
     put back when the colour changes or a size change resets it. Zoom keeps working: each slide still opens its own
     image (the zoom dialog's list is untouched). A colour with fewer than 3 photos leaves the gallery as it is. */
  const COL_MIN = 3;
  // Closing zoom tells the gallery which photo to show by its place in the full list; map it to the filtered list.
  document.addEventListener('zoom-media:selected', (e) => {
    if (!galleryAll || !e.detail || typeof e.detail.index !== 'number') return;
    const live = galleryAll.slides.filter((s) => s.isConnected);
    if (live.length === galleryAll.n) return;
    const off = galleryAll.slides[0] && !galleryAll.slides[0].dataset.ygmCol ? 1 : 0; // a drawn colour slide has no zoom entry
    const j = live.indexOf(galleryAll.slides[e.detail.index + off]);
    e.detail.index = j < 0 ? 0 : j;
  }, true);
  function colourKey(name) {
    const n = String(name || '').toLowerCase();
    if (n.includes('oasis')) return 'oasis-blue';
    if (n.includes('midnight')) return 'midnight-blue';
    if (n.includes('gray') || n.includes('grey') || n.includes('silverback')) return 'gray';
    return 'black';
  }
  let galleryAll = null;
  function filterGallery(key) {
    const show = document.querySelector('media-gallery slideshow-component');
    if (!show) return;
    const scroller = show.querySelector('[ref="scroller"]') || (show.querySelector('slideshow-slide') || {}).parentElement;
    const thumbBox = show.querySelector('.slideshow-controls__thumbnails');
    if (!scroller) return;
    if (!galleryAll) {
      galleryAll = {
        slides: [...scroller.querySelectorAll(':scope > slideshow-slide')],
        thumbs: thumbBox ? [...thumbBox.querySelectorAll(':scope > .slideshow-controls__thumbnail')] : [],
        totals: [...show.querySelectorAll('.slideshow-controls__counter')].map((c) => [c, c.lastChild && c.lastChild.nodeType === 3 ? c.lastChild : null]),
      };
      galleryAll.n = galleryAll.slides.length;
      if (galleryAll.thumbs.length !== galleryAll.n) galleryAll.thumbs = [];
    }
    const { slides, thumbs, totals, n } = galleryAll;
    const col = (el) => el.dataset.ygmCol || 'any';
    let keep = slides.map(() => true);
    if (key) {
      const match = slides.map((s) => col(s) === key || col(s) === 'any');
      if (slides.filter((s) => col(s) === key).length >= COL_MIN) keep = match;
    }
    const shown = keep.filter(Boolean).length;
    const now = slides.filter((s) => s.isConnected).length;
    if (shown === now && slides.every((s, i) => s.isConnected === keep[i])) return;
    slides.forEach((s, i) => { if (keep[i]) scroller.append(s); else s.remove(); });
    if (thumbs.length) {
      let j = 0;
      thumbs.forEach((t, i) => {
        if (!keep[i]) { t.remove(); return; }
        t.setAttribute('on:click', `/select/${j}`);
        t.setAttribute('aria-label', t.getAttribute('aria-label').replace(/\d+(\D+)\d+\s*$/, `${j + 1}$1${shown}`));
        thumbBox.append(t); j++;
      });
    }
    totals.forEach(([, t]) => { if (t) t.textContent = String(shown); });
    requestAnimationFrame(() => {
      scroller.scrollLeft = 0;
      if (typeof show.select === 'function') show.select(0, undefined, { animate: false });
      const cur = show.querySelector('.slideshow-controls__counter [ref="current"]');
      if (cur) cur.textContent = '1';
      if (thumbs.length) thumbs.filter((t) => t.isConnected).forEach((t, i) => t.setAttribute('aria-selected', String(i === 0)));
    });
  }
  document.addEventListener('click', (e) => {
    const chip = e.target.closest && e.target.closest('[data-ygm-colors] button.ygm-gcol__chip');
    if (chip) pickColour(chip);
  });
  document.addEventListener('submit', (e) => {
    if (!colourVid) return;
    const i = e.target instanceof HTMLFormElement && e.target.querySelector('input[name="id"]');
    if (i && e.target.closest('product-form-component')) i.value = colourVid;
  }, true);

  /* Cart page (cart.dirG): the steppers and the quantity box post to /cart/change.js (steps are batched for a moment
     so three quick taps send one request), Remove posts quantity 0, then the page's cart body is fetched again and
     swapped in place: totals, Shop Pay instalments and the header count all come from Liquid, never from JS maths.
     The express checkout buttons are kept as they are (they read the cart when tapped). Focus returns to the same
     control on the same line, or to the heading when the line is gone, and a status line announces the change. A
     refused change (not enough stock) shows Shopify's message under the line. Any failure falls back to a reload, as
     does an emptied cart (so the page's empty-cart sections render). */
  function initCartPage(root) {
    root.querySelectorAll('[data-ygm-cart-page]:not([data-ready])').forEach((page) => {
      page.dataset.ready = '1';
      const live = page.querySelector('[data-cart-live]');
      const say = (t) => { if (!live) return; live.textContent = ''; setTimeout(() => { live.textContent = t; }, 60); };
      let queue = Promise.resolve();
      const timers = new Map();

      const rerender = async (focus) => {
        const r = await fetch(location.href, { headers: { accept: 'text/html' }, credentials: 'same-origin' });
        if (!r.ok) throw new Error(String(r.status));
        const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
        const next = doc.querySelector('[data-ygm-cart-page] [data-cart-body]');
        const cur = page.querySelector('[data-cart-body]');
        if (!next || !cur) throw new Error('no cart body');
        if (next.querySelector('.ygm-gcart__empty')) { location.reload(); return null; }
        const fresh = document.importNode(next, true);
        const oldX = cur.querySelector('.ygm-gcart__express');
        const newX = fresh.querySelector('.ygm-gcart__express');
        if (oldX && newX) newX.replaceWith(oldX);
        cur.replaceWith(fresh);
        const nb = doc.querySelector('[data-ygm-cart]');
        const ob = document.querySelector('[data-ygm-cart]');
        if (nb && ob) {
          ob.setAttribute('aria-label', nb.getAttribute('aria-label') || '');
          const a = ob.querySelector('.ygm-cartbtn__n');
          const b = nb.querySelector('.ygm-cartbtn__n');
          if (a && b) { a.textContent = b.textContent; a.hidden = b.hidden; }
        }
        let target = null;
        if (focus && focus.key) {
          const li = [...fresh.querySelectorAll('[data-key]')].find((x) => x.dataset.key === focus.key);
          if (li) target = li.querySelector(focus.sel) || li.querySelector('[data-qty-input]');
        }
        if (!target && focus) { target = fresh.querySelector('.ygm-gcart__h1'); if (target) target.tabIndex = -1; }
        if (target && document.activeElement !== target) target.focus({ preventScroll: true });
        return fresh;
      };

      const commit = (key, qty, sel, name) => {
        queue = queue.then(async () => {
          page.setAttribute('aria-busy', 'true');
          let err = '';
          try {
            const r = await fetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'content-type': 'application/json', accept: 'application/json' },
              body: JSON.stringify({ id: key, quantity: qty }),
            });
            if (!r.ok) {
              const j = await r.json().catch(() => ({}));
              err = j.description || j.message || 'That change did not go through. Please try again.';
            }
            const fresh = await rerender({ key, sel });
            if (!fresh) return;
            if (err) {
              const li = [...fresh.querySelectorAll('[data-key]')].find((x) => x.dataset.key === key);
              const box = li && li.querySelector('[data-cart-err]');
              if (box) { box.textContent = err; box.hidden = false; }
              say(err);
            } else {
              say(qty === 0 ? `Removed ${name}.` : `Quantity of ${name} is now ${qty}.`);
            }
          } catch (e) {
            location.reload();
          } finally {
            page.removeAttribute('aria-busy');
          }
        });
      };

      const lineOf = (el) => el.closest('[data-key]');
      const nameOf = (li) => {
        const n = li.querySelector('.ygm-gcart__name');
        const z = li.querySelector('.ygm-gcart__size');
        return `${n ? n.textContent.trim() : 'item'}${z ? ` ${z.textContent.trim()}` : ''}`;
      };
      const schedule = (li, sel, delay) => {
        if (!li) return;
        const key = li.dataset.key;
        const input = li.querySelector('[data-qty-input]');
        const q = parseInt(input.value, 10);
        if (Number.isNaN(q) || q < 0) { input.value = li.dataset.qty; return; }
        clearTimeout(timers.get(key));
        if (String(q) === li.dataset.qty) return;
        timers.set(key, setTimeout(() => {
          timers.delete(key);
          li.dataset.qty = String(q);
          commit(key, q, sel, nameOf(li));
        }, delay));
      };

      page.addEventListener('click', (e) => {
        const step = e.target.closest('[data-qty-step]');
        const rem = e.target.closest('[data-remove-line]');
        if (step) {
          const li = lineOf(step);
          const input = li && li.querySelector('[data-qty-input]');
          if (!input) return;
          const q = Math.max(0, (parseInt(input.value, 10) || 0) + Number(step.dataset.qtyStep));
          input.value = String(q);
          schedule(li, `[data-qty-step="${step.dataset.qtyStep}"]`, q === 0 ? 0 : 350);
        } else if (rem) {
          const li = lineOf(rem);
          if (!li) return;
          e.preventDefault();
          li.querySelector('[data-qty-input]').value = '0';
          schedule(li, '[data-remove-line]', 0);
        }
      });
      page.addEventListener('change', (e) => {
        const input = e.target.closest('[data-qty-input]');
        if (input) schedule(lineOf(input), '[data-qty-input]', 0);
      });
      page.addEventListener('keydown', (e) => {
        const input = e.target.closest('[data-qty-input]');
        if (input && e.key === 'Enter') { e.preventDefault(); schedule(lineOf(input), '[data-qty-input]', 0); }
      });
    });
  }

  /* Cart drawer (Horizon's, shared by every direction): on dirG pages each mat line gets the short name, the picture the
     cart page uses (a photo that shows its colour, or the mat drawn in it), "6′ × 4′" with a colour swatch and name, the inches/area/thickness line, and links that keep the
     dirG view. The details come from #ygm-cart-map in the dirG header; a line it does not know (added from another
     page) triggers one re-request of the header section. Horizon re-renders the drawer on every cart change, so a
     MutationObserver re-applies the details; it runs before the next paint, so the store titles never flash. */
  const MAP = {};
  const readMap = (doc) => {
    const el = doc.getElementById('ygm-cart-map');
    if (el) { try { Object.assign(MAP, JSON.parse(el.textContent)); } catch (e) { /* keep what we have */ } }
  };
  let mapFetch = null;
  const fetchMap = () => {
    if (mapFetch) return mapFetch;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    mapFetch = fetch(`${root}?sections=ygm-g-header`, { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((j) => {
        const html = j && j['ygm-g-header'];
        if (html) readMap(new DOMParser().parseFromString(html, 'text/html'));
      })
      .catch(() => {})
      .finally(() => { patchDrawer(true); setTimeout(() => { mapFetch = null; }, 0); });
    return mapFetch;
  };
  /* No photo shows this colour (Midnight Blue, say): the thumbnail is the mat drawn to its proportions in that colour
     on the light floor tone, as on the cart page. */
  const tileSrc = (hex, l, w) => {
    const W = 76;
    const H = Math.round((76 * Number(w)) / Number(l) * 10) / 10;
    const mat = `x="${(100 - W) / 2}" y="${(100 - H) / 2}" width="${W}" height="${H}"`;
    const svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs>'
      + '<linearGradient id="l" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#fff" stop-opacity=".16"/>'
      + '<stop offset=".45" stop-color="#fff" stop-opacity="0"/><stop offset="1" stop-color="#000" stop-opacity=".14"/></linearGradient>'
      + '<filter id="s" x="-20%" y="-20%" width="140%" height="160%"><feDropShadow dx="0" dy="2" stdDeviation="2" flood-opacity=".28"/></filter>'
      + `</defs><rect width="100" height="100" fill="#f4f4f3"/><rect ${mat} fill="${hex}" filter="url(#s)"/><rect ${mat} fill="url(#l)"/></svg>`;
    return `data:image/svg+xml,${encodeURIComponent(svg)}`;
  };
  function patchRow(row) {
    const id = (row.dataset.key || '').split(':')[0];
    const e = MAP[id];
    if (!e) return false;
    const title = row.querySelector('.cart-items__title');
    if (title && e.n && title.textContent.trim() !== e.n) title.textContent = e.n;
    if (e.u) {
      row.querySelectorAll('a.cart-items__title, a.cart-items__media-container').forEach((a) => {
        if (a.getAttribute('href') !== e.u) a.setAttribute('href', e.u);
      });
    }
    const img = row.querySelector('img.cart-items__media-image');
    const src = e.i || (e.h && e.l && e.w ? tileSrc(e.h, e.l, e.w) : '');
    if (img && src && img.getAttribute('src') !== src) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.setAttribute('src', src);
      img.setAttribute('alt', '');
    }
    const wrap = row.querySelector('.cart-items__variants-wrapper');
    if (wrap && e.s) {
      const have = wrap.querySelector(':scope > .ygm-gdv');
      if (!have || have.dataset.v !== id) {
        if (have) have.remove();
        const box = document.createElement('div');
        box.className = 'ygm-gdv';
        box.dataset.v = id;
        const line = document.createElement('p');
        line.className = 'ygm-gdv__line';
        const size = document.createElement('span');
        size.textContent = e.s;
        line.append(size);
        if (e.c) {
          const c = document.createElement('span');
          c.className = 'ygm-gdv__c';
          if (e.h) {
            const i = document.createElement('i');
            i.style.setProperty('--c', e.h);
            i.setAttribute('aria-hidden', 'true');
            c.append(i);
          }
          c.append(document.createTextNode(e.c));
          line.append(c);
        }
        box.append(line);
        if (e.p) {
          const sp = document.createElement('p');
          sp.className = 'ygm-gdv__spec';
          sp.textContent = e.p;
          box.append(sp);
        }
        wrap.prepend(box);
      }
    }
    return true;
  }
  function patchDrawer(noFetch) {
    const d = document.getElementById('cart-drawer');
    if (!d) return;
    let missing = false;
    d.querySelectorAll('.cart-items__table-row[data-key]').forEach((row) => { if (!patchRow(row)) missing = true; });
    if (missing && !noFetch) fetchMap();
    patchDrawerPromise();
    // the drawer's tax note comes from the theme locale ("Free shipping. Taxes calculated at checkout.", SEO review A 3.1)
  }
  let drawerReady = false;
  function initDrawer() {
    if (drawerReady || !document.body.classList.contains('ygm-g')) return;
    drawerReady = true;
    readMap(document);
    patchDrawer();
    let queued = false;
    const inDrawer = (n) => {
      const el = n.nodeType === 1 ? n : n.parentElement;
      return !!(el && el.closest('#cart-drawer'));
    };
    new MutationObserver((list) => {
      if (queued || !list.some((m) => inDrawer(m.target))) return;
      queued = true;
      queueMicrotask(() => { queued = false; patchDrawer(); });
    }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['src', 'href', 'data-key'] });
  }

  /* FAQ: the search filters as you type (every word has to appear in the question or its answer; "6x4", "6' x 4'"
     and "6′ × 4′" all match), hides topics left empty, opens the matches when there are four or fewer, and puts back
     what was open once the box is cleared (Escape clears it); Enter goes to the first match. A link to #question opens
     that question. */
  function initFaq(root) {
    root.querySelectorAll('[data-ygm-faq]:not([data-ready])').forEach((sec) => {
      sec.dataset.ready = '1';
      const qas = [...sec.querySelectorAll('[data-faq-qa]')];
      const topics = [...sec.querySelectorAll('[data-faq-topic]')];
      const wrap = sec.querySelector('[data-faq-search]');
      const input = sec.querySelector('[data-faq-q]');
      const count = sec.querySelector('[data-faq-count]');
      const none = sec.querySelector('[data-faq-none]');
      const term = sec.querySelector('[data-faq-term]');
      const norm = (t) => t.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[′’‘`]/g, "'").replace(/[″“”]/g, '"').replace(/×/g, 'x').replace(/[–—]/g, '-')
        .replace(/(\d+)\s*['"]?\s*(?:x|by)\s*(\d+)\s*['"]?/g, '$1x$2').replace(/\s+/g, ' ');
      const text = qas.map((d) => norm(d.textContent));
      const total = qas.length;
      let saved = null;
      const openHash = () => {
        const id = decodeURIComponent(location.hash.slice(1));
        const el = id && document.getElementById(id);
        const d = el && (el.matches('details') ? el : el.closest('details'));
        if (d && sec.contains(d)) d.open = true;
      };
      openHash();
      window.addEventListener('hashchange', openHash);
      if (!wrap || !input) return;
      count.textContent = `${total} questions`;
      const apply = () => {
        const raw = input.value.trim();
        const words = norm(raw).split(' ').filter(Boolean);
        if (words.length && !saved) saved = qas.map((d) => d.open);
        let n = 0;
        qas.forEach((d, i) => {
          const hit = !words.length || words.every((w) => text[i].includes(w));
          d.hidden = !hit;
          if (hit) n += 1;
        });
        topics.forEach((t) => { t.hidden = !t.querySelector('[data-faq-qa]:not([hidden])'); });
        if (words.length) {
          if (n <= 4) qas.forEach((d) => { if (!d.hidden) d.open = true; });
        } else if (saved) {
          qas.forEach((d, i) => { d.open = saved[i]; });
          saved = null;
        }
        none.hidden = n > 0;
        if (term) term.textContent = raw;
        count.textContent = words.length ? (n === 1 ? `1 of ${total} questions matches` : `${n} of ${total} questions match`) : `${total} questions`;
      };
      let timer;
      input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(apply, 140); });
      input.addEventListener('search', apply);
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && input.value) { e.preventDefault(); input.value = ''; apply(); }
        if (e.key === 'Enter') {
          // Enter (the phone keyboard's search key) closes the keyboard and goes to the first match or the no-match note
          e.preventDefault(); clearTimeout(timer); apply();
          if (!input.value.trim()) return;
          const to = qas.find((d) => !d.hidden) || none;
          input.blur();
          to.scrollIntoView({ block: 'start' });
        }
      });
    });
  }

  /* Blog post contents: open beside the post on wide screens (the heading stays a label there), a closed list above
     it on phones that closes again after a jump; the heading being read is marked. */
  function initArticleToc(root) {
    root.querySelectorAll('[data-gart-toc]:not([data-ready])').forEach((d) => {
      d.dataset.ready = '1';
      const mq = matchMedia('(min-width: 990px)');
      const sync = () => { if (mq.matches) d.open = true; };
      sync();
      mq.addEventListener('change', sync);
      d.querySelector('summary').addEventListener('click', (e) => { if (mq.matches) e.preventDefault(); });
      const links = [...d.querySelectorAll('a[href^="#"]')];
      const heads = links.map((a) => document.getElementById(decodeURIComponent(a.hash.slice(1))));
      links.forEach((a) => a.addEventListener('click', () => { if (!mq.matches) d.open = false; }));
      let on = -1, queued = false;
      const mark = () => {
        queued = false;
        let i = -1;
        heads.forEach((h, k) => { if (h && h.getBoundingClientRect().top < 160) i = k; });
        if (i === on) return;
        if (on >= 0) links[on].classList.remove('is-on');
        if (i >= 0) {
          links[i].classList.add('is-on');
          // a contents list taller than the screen scrolls on its own: keep the current entry in view
          const box = d.closest('.ygm-gart__toc');
          if (box && box.scrollHeight > box.clientHeight + 2) {
            const r = links[i].getBoundingClientRect(), b = box.getBoundingClientRect();
            if (r.top < b.top + 56 || r.bottom > b.bottom - 24) box.scrollTop += r.top - b.top - b.height / 3;
          }
        }
        on = i;
      };
      document.addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(mark); } }, { passive: true, capture: true });
      mark();
    });
  }

  /* ---- CRO pass 2026-10-19 (owner items 4, 5, 6, 7) ---- */

  /* Delivery estimate: the published promise (ships in 1-2 business days, arrives 3-7 after) as dates. Business days
     skip weekends and the main US carrier holidays. Every [data-ygm-delivery] (product page, cart drawer) is filled. */
  const nthDow = (y, m, dow, n) => { const d = new Date(y, m, 1); d.setDate(1 + ((dow - d.getDay() + 7) % 7) + 7 * (n - 1)); return d; };
  const lastDow = (y, m, dow) => { const d = new Date(y, m + 1, 0); d.setDate(d.getDate() - ((d.getDay() - dow + 7) % 7)); return d; };
  const holidays = (y) => [new Date(y, 0, 1), lastDow(y, 4, 1), new Date(y, 6, 4), nthDow(y, 8, 1, 1), nthDow(y, 10, 4, 4), new Date(y, 11, 25)].map((d) => d.toDateString());
  const addBiz = (from, n) => {
    const d = new Date(from); let hs = holidays(d.getFullYear());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getMonth() === 0 && d.getDate() === 1) hs = holidays(d.getFullYear());
      if (d.getDay() !== 0 && d.getDay() !== 6 && !hs.includes(d.toDateString())) n--;
    }
    return d;
  };
  const deliveryRange = (min, max) => {
    const now = new Date(), a = addBiz(now, min), b = addBiz(now, max);
    const md = { month: 'short', day: 'numeric' };
    const left = a.toLocaleDateString('en-US', md);
    const right = a.getMonth() === b.getMonth() ? String(b.getDate()) : b.toLocaleDateString('en-US', md);
    return `${left} – ${right}`;
  };
  function fillDelivery(root) {
    root.querySelectorAll('[data-ygm-delivery]:not([data-ready])').forEach((el) => {
      el.dataset.ready = '1';
      el.innerHTML = `${'<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><circle cx="7" cy="17.5" r="1.7" fill="#fff" stroke="currentColor" stroke-width="1.6"/><circle cx="17.5" cy="17.5" r="1.7" fill="#fff" stroke="currentColor" stroke-width="1.6"/></svg>'}<span>Order today, arrives <strong>${deliveryRange(+el.dataset.min || 4, +el.dataset.max || 9)}</strong>. Free shipping.</span>`;
      el.hidden = false;
    });
  }

  /* "Find your mat" quiz (snippets/ygm-quiz.liquid, owner 10-19): shoes on or barefoot, who, where, anyone tall → one
     mat line and one size from the sizes the store has in stock, with its live price. Opened from the header and from
     the product page's "Help me choose" (data-quiz-line = that page's line): when the pick is that page's line, "Choose
     this size" checks the size tile on the page (Horizon does the rest); otherwise the result links to the pick. */
  const HELP = { 1: ['6x4', '7x5', '9x6'], 2: ['7x5', '9x6', '12x6'], 3: ['9x6', '12x6', '15x6'] };
  const QSTEPS = ['type', 'who', 'room', 'tall'];
  const area = (s) => s.split('x').reduce((x, y) => x * y, 1);
  const feet = (k) => `${k.replace('x', '′ × ')}′`;
  function quizSize(line, a, have) {
    let k = HELP[a.who][a.room - 1];
    if (a.tall && k === '6x4') k = line === 'yoga' ? '7x5' : '8x4';
    else if (a.tall && k === '7x5' && line === 'yoga') k = '9x6';
    if (!have.includes(k)) {
      const big = have.slice().sort((x, y) => area(x) - area(y));
      k = big.find((s) => area(s) >= area(k)) || big[big.length - 1];
    }
    return k;
  }
  let quizCtx = null;
  function initQuiz(root) {
    const dlg = document.querySelector('[data-ygm-quiz]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    root.querySelectorAll('[data-quiz-open][hidden]').forEach((b) => { b.hidden = false; });
    if (dlg.dataset.ready) return;
    dlg.dataset.ready = '1';
    let data = {};
    try { data = JSON.parse(dlg.querySelector('[data-quiz-data]').textContent); } catch (e) { return; }
    const q = (sel) => dlg.querySelector(sel);
    const ans = {};
    let step = 0;
    const show = () => {
      const done = step >= QSTEPS.length;
      dlg.querySelectorAll('[data-quiz-q]').forEach((f, i) => { f.hidden = i !== step; });
      q('[data-quiz-out]').hidden = !done;
      q('[data-quiz-count]').textContent = done ? 'Your mat' : `${step + 1} of ${QSTEPS.length}`;
      q('[data-quiz-bar]').style.width = `${Math.min(step, QSTEPS.length) / QSTEPS.length * 100}%`;
      q('[data-quiz-back]').hidden = step === 0 || done;
      q('[data-quiz-again]').hidden = !done;
      if (done) result();
      const f = done ? q('[data-quiz-out] .ygm-gbtn:not([hidden])') : dlg.querySelectorAll('[data-quiz-q]')[step].querySelector('button');
      if (f) f.focus({ preventScroll: true });
    };
    const result = () => {
      const line = ans.type === 'yoga' ? 'yoga' : 'exercise';
      const L = data[line];
      const have = L ? Object.keys(L.sizes) : [];
      if (!have.length) return;
      const k = quizSize(line, ans, have);
      const s = L.sizes[k];
      const out = q('[data-quiz-out]');
      q('[data-quiz-size]').textContent = feet(k);
      q('[data-quiz-line]').textContent = `${line} mat`;
      q('[data-quiz-price]').textContent = s.price;
      q('[data-quiz-why]').textContent = s.best ? `Best for ${s.best.toLowerCase()}.` : '';
      const img = q('[data-quiz-img]');
      if (L.img) { img.src = L.img; img.alt = L.alt || ''; }
      let note = '';
      if (ans.type === 'both') note = 'If shoes go on some days, pick the exercise mat: it takes shoes and weights, and works barefoot too.';
      else if (quizCtx && quizCtx !== line) note = line === 'yoga' ? 'For barefoot yoga and stretching, the yoga mat is the better fit: 8mm thick, with a sticky grip designed for bare feet.' : 'For workouts in shoes, the exercise mat is the one: it takes shoes and weights.';
      q('[data-quiz-note]').textContent = note; q('[data-quiz-note]').hidden = !note;
      const tile = quizCtx === line && document.querySelector(`.ygm-gsize__set input[data-ygm-size="${k}"]`);
      const choose = q('[data-quiz-choose]'), go = q('[data-quiz-go]');
      choose.hidden = !tile; go.hidden = !!tile;
      choose.textContent = `Choose the ${feet(k)}`;
      go.textContent = `See the ${feet(k)} ${line} mat`;
      go.href = `${L.url}${L.url.includes('?') ? '&' : '?'}variant=${s.id}`;
      out.dataset.k = k;
    };
    const open = (ctx) => {
      quizCtx = ctx || null;
      step = 0; QSTEPS.forEach((k) => delete ans[k]);
      dlg.querySelectorAll('[data-quiz-q] button').forEach((b) => b.setAttribute('aria-pressed', 'false'));
      const menu = document.querySelector('details.ygm-menu[open]'); if (menu) menu.open = false;
      dlg.showModal(); show();
    };
    document.addEventListener('click', (e) => {
      const b = e.target.closest('[data-quiz-open]');
      if (b) { e.preventDefault(); open(b.dataset.quizLine); }
    });
    dlg.addEventListener('click', (e) => {
      if (e.target === dlg || e.target.closest('[data-quiz-close]')) { dlg.close(); return; }
      const b = e.target.closest('[data-quiz-q] button');
      if (b) {
        const key = b.closest('[data-quiz-q]').dataset.quizQ;
        ans[key] = key === 'type' ? b.dataset.v : +b.dataset.v;
        b.closest('[data-quiz-q]').querySelectorAll('button').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
        step = QSTEPS.indexOf(key) + 1; show(); return;
      }
      if (e.target.closest('[data-quiz-back]')) { step = Math.max(0, step - 1); show(); return; }
      if (e.target.closest('[data-quiz-again]')) { step = 0; show(); return; }
      if (e.target.closest('[data-quiz-choose]')) {
        const t = document.querySelector(`.ygm-gsize__set input[data-ygm-size="${q('[data-quiz-out]').dataset.k}"]`);
        dlg.close();
        if (t) { t.click(); t.focus({ preventScroll: true }); }
      }
    });
  }

  /* Reviews of one size: Judge.me's public storefront feed (CORS open) for that size's own product, parsed into
     plain records. Cached per product and page. */
  const revCache = new Map();
  async function revFeed(shop, pid, page) {
    const key = `${pid}:${page}`;
    if (!revCache.has(key)) {
      revCache.set(key, fetch(`https://judge.me/reviews/reviews_for_widget?url=${shop}&shop_domain=${shop}&platform=shopify&page=${page}&per_page=5&product_id=${pid}`)
        .then((r) => r.json()).then((j) => {
          const doc = new DOMParser().parseFromString(j.html || '', 'text/html');
          const items = [...doc.querySelectorAll('.jdgm-rev')].map((r) => ({
            score: +(r.querySelector('[data-score]') || {}).dataset?.score || 0,
            name: (r.querySelector('.jdgm-rev__author') || {}).textContent?.trim() || '',
            title: (r.querySelector('.jdgm-rev__title') || {}).textContent?.trim() || '',
            body: (r.querySelector('.jdgm-rev__body') || {}).textContent?.trim() || '',
            date: (r.querySelector('.jdgm-rev__timestamp') || {}).getAttribute?.('data-content') || '',
            verified: r.dataset.verifiedBuyer === 'true',
          }));
          return { total: j.total_count || 0, items };
        }).catch(() => { revCache.delete(key); return { total: 0, items: [] }; }));
    }
    return revCache.get(key);
  }
  const currentSize = () => {
    const t = document.querySelector('.ygm-gsize__set input[data-ygm-size]:checked');
    return t ? t.dataset.ygmSize : null;
  };
  const sizeName = (k) => k.replace('x', '×');
  const stars = (n) => '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n);
  const SKIP = /smell|odou?r|toxic|rubber|latex|pvc|tpe|chemical/i;
  const trimQuote = (s, max) => {
    if (s.length <= max) return s;
    const cut = s.slice(0, max), dot = Math.max(cut.lastIndexOf('. '), cut.lastIndexOf('! '));
    return dot > max * 0.5 ? cut.slice(0, dot + 1) : `${cut.slice(0, cut.lastIndexOf(' '))}…`;
  };
  const proofMap = () => { const s = document.querySelector('[data-proof-map]'); try { return s ? JSON.parse(s.textContent) : {}; } catch (e) { return {}; } };

  async function showProof(box) {
    const k = currentSize(); const map = proofMap(); const pid = k && map[k];
    const q = box.querySelector('[data-proof-q]'), more = box.querySelector('[data-proof-more]');
    if (!pid) { q.hidden = true; more.hidden = true; return; }
    const want = `${k}`; box.dataset.size = want;
    let pick = null, total = 0;
    for (let page = 1; page <= 3 && !pick; page++) {
      const f = await revFeed(box.dataset.shop, pid, page);
      total = f.total;
      pick = f.items.find((r) => r.score >= 4 && r.body.length >= 40 && !SKIP.test(`${r.title} ${r.body}`));
      if (f.items.length < 5) break;
    }
    if (box.dataset.size !== want) return;
    if (pick) {
      box.querySelector('[data-proof-text]').textContent = `“${trimQuote(pick.body, 170)}”`;
      box.querySelector('[data-proof-name]').textContent = `${stars(pick.score)} ${pick.name || 'Verified buyer'}`;
      box.querySelector('[data-proof-size]').textContent = `on the ${sizeName(k)}`;
      q.hidden = false;
    } else q.hidden = true;
    if (total > 0) { more.textContent = `Read reviews of the ${sizeName(k)}`; more.hidden = false; } else more.hidden = true;
  }
  function initProof(root) {
    root.querySelectorAll('[data-ygm-proof]:not([data-ready])').forEach((box) => {
      box.dataset.ready = '1';
      showProof(box);
      box.querySelector('[data-proof-more]').addEventListener('click', () => {
        const sec = document.getElementById('ygm-reviews');
        const tab = sec && sec.querySelector('[data-rev-tab="size"]');
        if (tab) tab.click();
        if (sec) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initReviewTabs(root) {
    root.querySelectorAll('#ygm-reviews [data-rev-tabs]:not([data-ready])').forEach((tabs) => {
      const map = proofMap(); const proof = document.querySelector('[data-ygm-proof]');
      if (!proof || !Object.keys(map).length) return;
      tabs.dataset.ready = '1';
      const sec = tabs.closest('#ygm-reviews');
      const all = sec.querySelector('#judgeme_product_reviews'), one = sec.querySelector('[data-rev-size]');
      const list = one.querySelector('[data-rev-list]'), pager = one.querySelector('[data-rev-page]'), count = one.querySelector('[data-rev-count]');
      let k = null, page = 0, mode = 'all';
      const label = () => { k = currentSize(); tabs.querySelector('[data-rev-size-name]').textContent = k ? sizeName(k) : 'This size'; };
      const load = async () => {
        page += 1;
        const f = await revFeed(proof.dataset.shop, map[k], page);
        count.textContent = `Reviews of the ${sizeName(k)}, newest first.`; // owner 10-19: no review counts
        f.items.forEach((r) => {
          const li = document.createElement('li');
          li.className = 'ygm-greviews__item';
          const h = document.createElement('p'); h.className = 'ygm-greviews__stars'; h.textContent = stars(r.score); h.setAttribute('aria-label', `${r.score} out of 5 stars`);
          const t = document.createElement('p'); t.className = 'ygm-greviews__title'; t.textContent = r.title;
          const b = document.createElement('p'); b.textContent = r.body;
          const n = document.createElement('p'); n.className = 'ygm-greviews__who'; n.textContent = `${r.name}${r.verified ? ' · Verified buyer' : ''}${r.date ? ` · ${new Date(r.date.replace(' UTC', 'Z').replace(' ', 'T')).toLocaleDateString('en-US', { month: 'short', year: 'numeric' })}` : ''}`;
          li.append(h); if (r.title) li.append(t); li.append(b, n); list.append(li);
        });
        pager.hidden = list.children.length >= f.total || f.items.length < 5;
      };
      const show = (m) => {
        mode = m;
        tabs.querySelectorAll('[data-rev-tab]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.revTab === m)));
        all.hidden = m !== 'all'; one.hidden = m === 'all';
        if (m === 'size' && list.dataset.k !== k) { list.innerHTML = ''; list.dataset.k = k; page = 0; load(); }
      };
      label();
      tabs.hidden = !k || !map[k];
      tabs.addEventListener('click', (e) => { const b = e.target.closest('[data-rev-tab]'); if (b) show(b.dataset.revTab); });
      pager.addEventListener('click', load);
      document.addEventListener('change', (e) => {
        if (!(e.target instanceof HTMLInputElement) || !e.target.closest('.ygm-gsize__set')) return;
        label(); tabs.hidden = !k || !map[k];
        if (mode === 'size') show('size');
      });
    });
  }

  /* Cart drawer reassurance (item 6): one line under the total with the arrival dates and the two promises. */
  function patchDrawerPromise() {
    const d = document.getElementById('cart-drawer');
    if (!d || !d.querySelector('.cart-items__table-row[data-key]')) return;
    const anchor = d.querySelector('.cart__summary-totals, .cart-totals, .cart__total, [class*="tax-note"], .cart__ctas');
    if (!anchor || d.querySelector('.ygm-drawer-promise')) return;
    const p = document.createElement('p');
    p.className = 'ygm-drawer-promise';
    p.innerHTML = `<span>Arrives <b>${deliveryRange(4, 9)}</b></span><span>60-day returns</span><span>Lifetime warranty</span>`;
    const ctas = d.querySelector('.cart__ctas');
    if (ctas) ctas.before(p); else anchor.after(p);
  }

  let croQueued = false;
  const croRun = () => { croQueued = false; fillDelivery(document); initQuiz(document); initProof(document); initReviewTabs(document); };
  // Horizon re-renders the product details on a size change; new copies of these blocks get set up again
  const CRO_SEL = '[data-ygm-delivery],[data-quiz-open],[data-ygm-quiz],[data-ygm-proof],[data-rev-tabs]';
  // Horizon's morph re-renders by adding nodes or by resetting attributes in place (a quiz button gets `hidden` back)
  const croAdded = (muts) => muts.some((m) => (m.type === 'attributes' ? m.target.matches('[data-quiz-open][hidden]')
    : [...m.addedNodes].some((n) => n.nodeType === 1 && (n.matches(CRO_SEL) || n.querySelector(CRO_SEL)))));
  new MutationObserver((muts) => { if (!croQueued && croAdded(muts)) { croQueued = true; requestAnimationFrame(croRun); } }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
  document.addEventListener('change', (e) => {
    if (e.target instanceof HTMLInputElement && e.target.closest('.ygm-gsize__set')) setTimeout(() => document.querySelectorAll('[data-ygm-proof][data-ready]').forEach(showProof), 60);
  });

  const run = (root) => {
    croRun();
    initLineups(root || document);
    initSizeGuides(root || document);
    initCartPage(root || document);
    initFaq(root || document);
    initArticleToc(root || document);
    initDrawer();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run()); else run();
  document.addEventListener('shopify:section:load', (e) => run(e.target));
})();
